const DAY_LABELS = {
  MON: 'Mon',
  TUE: 'Tue',
  WED: 'Wed',
  THU: 'Thu',
  FRI: 'Fri',
  SAT: 'Sat',
  SUN: 'Sun',
};

function normalizeText(value) {
  if (value == null) return null;
  const text = String(value).trim();
  return text || null;
}

function formatLocalTime(value) {
  const text = normalizeText(value);
  if (!text) return null;

  const [hoursRaw, minutesRaw = '00'] = text.split(':');
  const hours = Number(hoursRaw);
  const minutes = Number(minutesRaw);
  if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return text;

  const suffix = hours >= 12 ? 'PM' : 'AM';
  const displayHour = (hours % 12) || 12;
  return `${displayHour}:${String(minutes).padStart(2, '0')} ${suffix}`;
}

export function normalizeRestaurantHours(businessHours) {
  const periods = Array.isArray(businessHours?.periods) ? businessHours.periods : [];

  return periods
    .map((period) => {
      const dayCode = normalizeText(period?.day_of_week)?.toUpperCase();
      const start = formatLocalTime(period?.start_local_time);
      const end = formatLocalTime(period?.end_local_time);
      if (!dayCode || !start || !end) return null;

      return {
        day: DAY_LABELS[dayCode] || dayCode,
        time: `${start} - ${end}`,
      };
    })
    .filter(Boolean);
}

export default normalizeRestaurantHours;
